// extracted by mini-css-extract-plugin
export default {"Wrapper":"Layout_Wrapper__7j2lG","main-content":"Layout_main-content__iqQgw","nav-hide":"Layout_nav-hide__28VC6"};